import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import CrmIntegradoHotmart from "@/pages/CrmIntegradoHotmart";

export const Route = createFileRoute("/crm-integrado-hotmart")({
  head: () => buildHead({
    title: "CRM integrado com Hotmart e WhatsApp | OP2P",
    description: "Integre a Hotmart à OP2P CRM: compradores, carrinhos abandonados e alunos atendidos por Agentes de IA no WhatsApp e Instagram, 24 horas.",
    path: "/crm-integrado-hotmart",
  }),
  component: CrmIntegradoHotmart,
});
